import { useNavigate } from "react-router-dom";
import breadLogo from "../images/bread_logo_192.png";
import { buildClasses } from "../utils/buildClasses";
import { WebsiteButton } from "./WebsiteButton";

// The header sticks to the top of the window, so anything positioned against
// the top of the viewport (the feature tour's docked mock, for one) has to sit
// below it. Keep this in step with the h-16 below.
export const HEADER_HEIGHT_PX = 64;

export function Header() {
  const navigate = useNavigate();

  return (
    <header
      className={buildClasses("sticky", "top-0", "z-50", "w-full", "bg-base")}
    >
      {/* From md up, three columns, with the outer two sharing the leftover
          space equally, so the middle nav sits at the true center of the header
          no matter how wide the logo or the buttons are. On phones, where Log in
          and Sign up are hidden, just two: the nav moves to the right edge.
          Container matches the marketing sections so the logo lines up with the
          page's left edge. Keep these in step if either changes. */}
      <div
        className={buildClasses(
          "mx-auto",
          "grid",
          "h-16",
          "w-[92%]",
          "max-w-[1344px]",
          "grid-cols-[1fr_auto]",
          "md:grid-cols-[1fr_auto_1fr]",
          "items-center",
        )}
      >
        <div
          className={buildClasses(
            "flex",
            "w-fit",
            "cursor-pointer",
            "items-center",
            "gap-2",
            "text-xl",
            "font-medium",
            "text-purple",
          )}
          onClick={() => navigate("/")}
        >
          <img
            className={buildClasses("h-10")}
            src={breadLogo}
            alt="Bread logo"
          />
          Bread
        </div>

        <nav className={buildClasses("flex", "items-center", "gap-1")}>
          <WebsiteButton
            size="sm"
            variant="nav"
            onClick={() => navigate("/pricing")}
          >
            Pricing
          </WebsiteButton>
        </nav>

        {/* Hidden on phones, where the web app doesn't work well yet: pages
            show a mobile-app-coming-soon note instead (see SignUpAction). */}
        <div
          className={buildClasses(
            "hidden",
            "items-center",
            "justify-end",
            "gap-1",
            "md:flex",
          )}
        >
          <WebsiteButton
            size="sm"
            variant="plain"
            onClick={() => navigate("/auth")}
          >
            Log in
          </WebsiteButton>
          <div className={buildClasses("ml-1")}>
            <WebsiteButton size="sm" onClick={() => navigate("/auth/signup")}>
              Sign up
            </WebsiteButton>
          </div>
        </div>
      </div>
    </header>
  );
}
